import BestSellerSection from "./BestSellerSection.view";

export default BestSellerSection;
